import { ElementViewTemplate, html, ref, slotted, when } from '@microsoft/fast-element';
import { NatGenTextField } from './text-field';
import { endSlotTemplate, startSlotTemplate } from '../start-end/start-end';
import { TextFieldOptions } from './text-field.options';

export function textFieldTemplate<T extends NatGenTextField>(options: TextFieldOptions = {}) : ElementViewTemplate {
    return html<T>`
        <template>
            <div class="root" part="root">
                ${startSlotTemplate(options)}

                <span class="control-container">
                    <input
                        id="${x => x.internalId}"
                        class="control"
                        part="control"
                        ?autofocus="${x => x.autofocus}"
                        ?disabled="${x => x.disabled}"
                        list="${x => x.list}"
                        maxlength="${x => x.maxlength}"
                        minlength="${x => x.minlength}"
                        max="${x => x.max}"
                        min="${x => x.min}"
                        pattern="${x => x.pattern}"
                        placeholder="${x => x.placeholder || " "}"
                        inputmode="${x => x.inputMode}"
                        ?readonly="${x => x.readOnly}"
                        ?required="${x => x.required}"
                        size="${x => x.size}"
                        ?spellcheck="${x => x.spellcheck}"
                        type="${x => x.type}"
                        aria-atomic="${x => x.ariaAtomic}"
                        aria-busy="${x => x.ariaBusy}"
                        aria-controls="${x => x.ariaControls}"
                        aria-current="${x => x.ariaCurrent}"
                        aria-describedBy="${x => x.ariaDescribedby}"
                        aria-details="${x => x.ariaDetails}"
                        aria-disabled="${x => x.ariaDisabled}"
                        aria-errormessage="${x => x.ariaErrormessage}"
                        aria-flowto="${x => x.ariaFlowto}"
                        aria-haspopup="${x => x.ariaHaspopup}"
                        aria-hidden="${x => x.ariaHidden}"
                        aria-invalid="${x => x.ariaInvalid}"
                        aria-keyshortcuts="${x => x.ariaKeyshortcuts}"
                        aria-label="${x => x.ariaLabel}"
                        aria-labelledby="${x => x.ariaLabelledby}"
                        aria-live="${x => x.ariaLive}"
                        aria-owns="${x => x.ariaOwns}"
                        aria-relevant="${x => x.ariaRelevant}"
                        aria-roledescription="${x => x.ariaRoledescription}"
                        ${ref("control")}
                    />

                    <label
                        part="label"
                        for="${x => x.internalId}"
                        class="label"
                    >
                        <slot ${slotted("defaultSlottedNodes")}></slot>
                    </label>
                </span>

                ${when(x => x.isPasswordType, html`
                    <natgen-button class="password-toggle" variant="link" color="primary" @click="${x => x.togglePasswordVisibility()}">
                        ${when(x=> x.type === 'password', html`Show`)}
                        ${when(x=> x.type === 'text', html`Hide`)}
                    </natgen-button>
                `)}
                ${endSlotTemplate(options)}
            </div>
        </template>
    `
};
